<template>
    <div class="table_container">
        <common-layout>
            <div slot="header">
                <h3>科技市场</h3>
            </div>
            <div slot="container">
                <div class="handle-box">
                    <!-- 搜索项暂时注释 -->
                    <!-- <el-input style="width:30%;margin:0 10px" placeholder="视频关键词" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                    <el-select>
                        <el-option value label="全部"></el-option>
                        <el-option value="1" label="学习课程"></el-option>
                        <el-option value="2" label="点播课程"></el-option>
                    </el-select> -->
                </div>
                <div id="table">
                    <!--动态绑定长宽-->
                    <el-table ref="multipleTable" :data="tableData" style="width: 100%" type="index" @select="tabSelect"
                        @select-all="tabSelect" :header-cell-style="headerStyle">
                        <el-table-column type="selection" width="60"></el-table-column>
                        <el-table-column prop="categoryName" label="分类名称" align="center"></el-table-column>
                        <el-table-column prop="title" label="标题/名称" align="center" />
                        <el-table-column prop="image" label="图片" align="center">
                            <template slot-scope="scope">
                                <el-image :src="imgUrl + scope.row.image" :preview-src-list="[imgUrl + scope.row.image]">
                                </el-image>
                            </template>
                        </el-table-column>

                        <el-table-column prop="showOrder" label="显示顺序" align="center"></el-table-column>
                        <el-table-column prop="isShow" label="显示" align="center">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.isShow === 1">显示</el-tag>
                                <el-tag type="success" v-else-if="scope.row.isShow === 0">不显示</el-tag>
                                <el-tag type="success" v-else>未知</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="添加日期" align="center"></el-table-column>
                        <el-table-column prop="creatorName" label="操作员" align="center"></el-table-column>
                        <el-table-column label="操作" align="center" width="220">
                            <template slot-scope="scope">
                                <el-button-group>
                                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination">
                    <div class="grid-content bg-purple-light">
                        <el-pagination @current-change="handleCurrentChange" layout="total, prev, pager, next,jumper"
                            :total="total" :current-page.sync="current_page" :page-size="per_page"></el-pagination>
                    </div>
                </div>
            </div>
        </common-layout>
        <el-dialog title="修改科技市场管理" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
            <upData ref="upDataRef" @onSubmit="onSubmit" @onClose="onClose" />
        </el-dialog>
    </div>
</template>

<script>
import CommonLayout from "../../../components/common-layout.vue";
import upData from "./upData.vue";
export default {
    components: {
        CommonLayout,
        upData
    },
    data() {
        return {
            tableData: [], //列表数据
            total: 10, //总页数
            current_page: 1, //当前页
            per_page: 20, //每页条数
             dialogVisible: false, //弹窗显示状态
        };
    },
    created() {
        this.getData();
    },
    computed: {
    },
    methods: {
        //获取列表数据
        getData() {
            let params = {
                page: this.current_page,
                pageSize: this.per_page,
            }
            this.http.post('apij2/admin-api/voucher/large-screen-technology-market-management/page', params).then((response) => {
                this.tableData = response.data.data;
                this.total = response.data.total; //总页数
                this.per_page = response.data.per_page;
                this.current_page = response.data.current_page;
            });
        },
        //选择页码
        handleCurrentChange(e) {
            this.current_page = e;
            this.getData(this.pageSearchUrl);
        },
        //选择行数
        tabSelect(sec, row) {
            let ids = "";
            for (let i of sec) {
                ids += i.id + ",";
            }
            ids = ids.substr(0, ids.length - 1);
            this.selected = ids;
        },
        //编辑
        async handleEdit(row) {
            await this.http.get('apij2/admin-api/voucher/large-screen-technology-market-management/get?id=' + row.id).then((response) => {
                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.$refs.upDataRef.getData(response.data);
                });
            });
        },
        onSubmit() {
            this.onClose()
            this.getData();
        },
        onClose() {
            this.dialogVisible = false;
        }
    },
};
</script>
<style lang="scss" scoped>
* {
    word-break: normal;
}

.table_container {
    height: 100%;
    text-align: left;

    .handle-box {
        .handle-input {
            /deep/.el-input__suffix {
                margin-right: 10px;
            }
        }
    }

    #table {
        margin-top: 20px;
        border: 1px solid #eef1f6;

        /deep/ th {
            // background-color: #eef1f6 !important;
            // color: #000;
        }

        /deep/ td {}

        /deep/ .cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            img {
                max-width: 100px;
                max-height: 100%;
                width: auto;
                height: auto;
            }
        }

        p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .pagination {
        margin-top: 10px;
    }

    /deep/ .el-dialog__header {
        text-align: center !important;
    }
}

.mess {
    color: red;
    margin-left: 20px;
}
</style>
